import type { HeroSlide } from '../ui';

const KEY = 'fg:hero-slides';

/** Dernières slides du hero, gardées en local: au retour d'un visiteur, le hero s'affiche sans attendre l'API. */
export function readHeroCache(): HeroSlide[] {
  try {
    const raw = localStorage.getItem(KEY);
    const list = raw ? (JSON.parse(raw) as HeroSlide[]) : [];
    return Array.isArray(list) ? list.filter((s) => s && s.id && s.image) : [];
  } catch {
    return [];
  }
}

export function writeHeroCache(slides: HeroSlide[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(slides));
  } catch {
    /* stockage indisponible: on s'en passe */
  }
}
